import type { VaccinationReason } from './immunization';

export enum GOPCode {
  GOP_01480 = '01480',
  GOP_01732 = '01732',
  GOP_01734 = '01734',
  GOP_01740 = '01740',
  GOP_01747 = '01747',
  GOP_01748 = '01748',
  GOP_03360 = '03360',
}

export const INFLUENZA_ALERT_KEY = 'influenza';

export interface PreventionAlert {
  key: string;
  gopCode: GOPCode | null;
  eligibleNow: boolean;
  alertText: string;
  mostRecentYear: number | null;
  display: AlertDisplay;
  availableVaccinationReasons?: VaccinationReason[];
  lastPerformedAt?: string | null;
  recordable?: boolean;
}

export type SegmentStatus = 'pending' | 'done';

export interface AlertSegment {
  key: string;
  status: SegmentStatus;
  icon?: string | null;
  label?: string | null;
}

export interface AlertDisplay {
  kind: 'simple' | 'composite';
  segments: AlertSegment[];
}
